<template>
  <div class="sectionFive">
      <div class="mains">
        <div class="contact">
          <p class="contact_zh">联系我们</p>
          <div class="contact_en"></div>
        </div>
        <img class="qrcodes" src="../assets/qrcode.png" alt="">
        <div class="tel_num">
          <div class="tel"><span class="world">业务洽谈</span><span class="number">{{telNum}}</span></div>
          <div class="tel"><span class="world">投诉建议</span><span class="number">18027103455</span></div>
          <div class="tel"><span class="world">售后服务</span><span class="number">400-900-5939</span></div>
        </div>
        <div class="line"></div>
        <div class="five_buttom">
          <p class="email">marketing@weimaqi.com</p>
          <p class="address">广州市番禺区南村镇鸿创直街19号五楼(番禺工业经济总部园区禹能集团总部大楼五楼)</p>
        </div>
      </div>
      <div class="footer">
        <div class="logo">
          <ul>
            <li><a href="http://www.qqhhll.com/" target="_blank">趣互联</a><span>&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;</span></li>
            <li><router-link  to="/home" >维码器</router-link><span>&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;</span></li>
            <li><a href="http://www.allpaycloud.cn/" target="_blank">奥付云</a><span>&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;</span></li>
            <li><a href="http://www.kedlink.com/" target="_blank">科碟网络</a></li>
          </ul>
        </div>
        <p class="copyright">Copyright © 广州扬盛计算机软件 版权所有 粤ICP备15073043号</p>
      </div>
      <div class="top" @click="topBack()"><img src="../assets/top.png" alt=""></div>
  </div>
</template>

<script>
export default {
  name:"Five",
  data(){
    return{
      telNum: '',
      nums: [
        {tel:'18773232030',name:'王生'},
        {tel:'18929539209',name:'李生'},
        {tel:'13539860650',name:'湛生'},
        {tel:'15659363555',name:'杨生'},
        {tel:'13822274256',name:'付生'}
        ],
      oldTime: (new Date("2018/04/23 00:00:00")).getTime(),
      timestamp: new Date().getTime(),
    }
  },
  mounted () {
    var d = this.timestamp - this.oldTime;
    var week = 7*24*60*60*1000;
    var ns = Math.floor(d/week);
    var n = ns - (Math.floor(ns/5)*5);
    this.telNum = `${this.nums[n].tel}`;
  },
  methods: {
    topBack () {
      this.$emit('topBack')
    }
  }
}
</script>
  
<style scoped>

.sectionFive{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
}
.mains {
  width: 100%;
  height: 620px;
  background-color: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.contact {
  text-align: center;
}
.contact_zh {
	font-family: 微软雅黑;
	font-size: 24px;
	font-weight: bold;
	font-stretch: normal;
	letter-spacing: 1px;
	color: #333333;
}
.contact_en {
  width: 142px;
  height: 18px;
  background: url(../assets/CONTACT_WE.png) no-repeat;
  background-size: 100% 100%;
  margin-top: 11px;
}
.qrcodes {
  width: 140px;
  height: 140px;
  margin: 60px 0px;
}
.tel_num {
  display: flex;
}
.tel_num .tel {
  margin-right: 30px;
}
.tel .world {
  font-family: 微软雅黑;
  font-size: 14px;
  color: #333333;
  margin-right: 10px;
}
.tel .number {
  font-family: number-webfont;
  font-size: 20px;
  color: #333333;
}
.line {
  width: 2px;
	height: 50px;
  background-color: #333333;
  margin: 27px 0;
}
.five_buttom {
  text-align: center;
}
.five_buttom>p {
  font-family: 微软雅黑;
  font-size: 14px;
	letter-spacing: 0px;
	color: #333333;
}
.five_buttom .address {
  margin-top: 10px;
}
.footer {
  width: 1920px;
  height: 107px;
  background-color: #333333;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 14px;
  font-family: 微软雅黑;
}
.footer .logo {
  color: #fefefe;
}
.logo ul {
    display: flex;
    justify-content: center;
    align-items: center;
}
.logo ul>li a {
  color: #fefefe;
  cursor: pointer;
}
.logo ul>li:hover a {
  color: #016bff;
}
.footer .copyright {
  color: #999999;
  margin-top: 10px;
}
.top {
  width: 80px;
  height: 80px;
  position: absolute;
  bottom: 177px;
  right: 100px;
  cursor: pointer;
}
.top img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Five.vue